<template>
  <of-dialog :title="formTitle" :width="width"  @onCancel="cancel">
    <div slot="content">
      <el-form label-width="120px" :model="dataForm">
        <el-form-item label="支入金额：">
          {{ dataForm.Amount }}
        </el-form-item>
        <el-form-item label="资金来源：">
          {{ showSource(dataForm.Source) }}
        </el-form-item>
        <el-form-item label="拨款公益项目：" v-if="dataForm.Source == 0">
          {{ dataForm.ProjectName }}
        </el-form-item>
        <el-form-item label="收入时间：">
          {{ (dataForm.CreateTime * 1000) | formatDate2 }}
        </el-form-item>
        <el-form-item label="支出明细：">
          {{ dataForm.Describe }}
        </el-form-item>
        <el-form-item label="附件：">
          <el-upload
            class="upload-demo"
            action="/api/File/FileUpload"
            multiple
            :on-preview="onFilePreview"
            :file-list="fileList"
          >
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      width: "60%",
      Source: [
        { value: 0, label: "社会捐赠" },
        { value: 1, label: "财政拨款" },
        { value: 2, label: "其他" },
      ], //资金来源
      fileList: [], //文件上传数组
      formTitle:"查看详情"
    };
  },
  components: {
    OfDialog,
  },
  computed: {
    showSource() {
      return (data) => {
        switch (data) {
          case 0:
            return "社会捐赠";
          case 1:
            return "财政拨款";
          case 2:
            return "其他";
        }
      };
    },
  },
  mounted() {
      let that=this;
      that.getfile();
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //初始化附件
    getfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload--text {
  display: none !important;
}
.of-dialog >>> .el-button--primary {
  display: none;
}
.of-dialog >>> .el-button--default {
  display: none;
}
.upload-demo >>> .el-icon-close {
  display: none !important;
}
.upload-demo >>> .el-icon-close-tip {
  display: none !important;
}
.upload-demo>>>.el-upload-dragger{
    display: none !important;
}
</style>